import { FC } from 'react';

const LoveIt: FC<{ filled?: boolean }> = ({ filled }) => {
    const color = filled ? '#43A047' : '#BDBDBD';

    return (
        <svg
            width="50"
            height="50"
            viewBox="0 0 50 50"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_1438_5176)">
                <path
                    d="M25 49.2789C11.6186 49.2789 0.721191 38.3815 0.721191 25C0.721191 11.6186 11.6186 0.721191 25 0.721191C38.3815 0.721191 49.2789 11.6186 49.2789 25C49.2789 38.3815 38.3815 49.2789 25 49.2789ZM25 3.84619C13.3814 3.84619 3.84619 13.3814 3.84619 25C3.84619 36.6186 13.3013 46.0738 24.9199 46.0738C36.5385 46.0738 45.9936 36.6186 45.9936 25C46.0738 13.3814 36.6186 3.84619 25 3.84619Z"
                    fill={color}
                />
                <path
                    d="M25.4007 38.3815H25C16.9071 38.3815 13.2212 32.3719 12.5 29.2469C12.2596 28.2052 12.9808 27.2437 14.0225 27.2437H36.3782C37.4199 27.2437 38.2212 28.2052 37.9007 29.2469C37.0994 32.452 33.4936 38.3815 25.4007 38.3815ZM16.4263 30.4488C17.5481 32.452 20.0321 35.1763 25 35.1763H25.4007C30.3686 35.1763 32.8526 32.452 33.9744 30.4488H16.4263Z"
                    fill={color}
                />
                <path
                    d="M16.5865 23.077C18.1353 23.077 19.391 21.8214 19.391 20.2725C19.391 18.7236 18.1353 17.468 16.5865 17.468C15.0376 17.468 13.782 18.7236 13.782 20.2725C13.782 21.8214 15.0376 23.077 16.5865 23.077Z"
                    fill={color}
                />
                <path
                    d="M33.1731 23.077C34.722 23.077 35.9776 21.8214 35.9776 20.2725C35.9776 18.7236 34.722 17.468 33.1731 17.468C31.6243 17.468 30.3687 18.7236 30.3687 20.2725C30.3687 21.8214 31.6243 23.077 33.1731 23.077Z"
                    fill={color}
                />
            </g>
            <defs>
                <clipPath id="clip0_1438_5176">
                    <rect width="50" height="50" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default LoveIt;
